import type {
  ShapeRevenueGroup,
  ShapeRevenueGroupBase,
} from "@aprao/model/src/shapes/ShapeRevenueGroup.js";

export const buildRevenueGroupName = (
  group: ShapeRevenueGroup,
  groups: Array<ShapeRevenueGroupBase>,
) =>
  group.name.length === 0 ?
    `${group.category === "other" ? "Other income" : "Unit type"} ${
      groups.indexOf(group) + 1
    }`
  : group.name;
